export const allCurrency = [
  {
    "code": "INR",
    "symbol": "₹",
    "name": "Indian Rupee"
  },
    {
      "code": "USD",
      "symbol": "$",
      "name": "US Dollar"
    },
    {
      "code": "EUR",
      "symbol": "€",
      "name": "Euro"
    },
    {
      "code": "AED",
      "symbol": "د.إ",
      "name": "United Arab Emirates dirham",
    },
    {
      "code": "JPY",
      "symbol": "¥",
      "name": "Japanese Yen"
    },
    {
      "code": "GBP",
      "symbol": "£",
      "name": "British Pound"
    },
    {
      "code": "AUD",
      "symbol": "$",
      "name": "Australian Dollar"
    },
      {
      "code": "CAD",
      "symbol": "$",
      "name": "Canadian Dollar"
    },
    {
      "code": "CHF",
      "symbol": "CHF",
      "name": "Swiss Franc"
    },
    {
      "code": "CNY",
      "symbol": "¥",
      "name": "Chinese Yuan"
    },
    {
      "code": "KRW",
      "symbol": "₩",
      "name": "Korean Won"
    },
      {
      "code": "BRL",
      "symbol": "R$",
      "name": "Brazilian Real"
    },
    {
      "code": "RUB",
      "symbol": "₽",
      "name": "Russian Ruble"
    },
    {
      "code": "TRY",
      "symbol": "₺",
      "name": "Turkish Lira"
    }
  ]

  export const currencySymbolByCode = (code) => {
    const curr =  allCurrency.find((c) => c.code === code);
    if(curr){
      return curr?.symbol;
    }
  };